<div *ngIf="pdf" class="pdf-container d-flex justify-content-center">
  <div class="pdf-image">
    <img *ngIf="pdf.newspaper_name === 'A19'" class="a19-header" [src]="config.a19PdfHeader" loading="lazy">
    <img [src]="pdf.thumbnail_big" loading="lazy" (click)="downloadPdf(pdf)" class="img-fluid" alt="{{ pdf.publish_number }}">
  </div>
  <div class="content">
    <div class="pdf-data ms-4">
      <p class="pdf-edition mb-1">
        <ng-container [ngSwitch]="pdf.newspaper_subname">
          <ng-container *ngSwitchCase="'woch'">Die heutige Ausgabe</ng-container>
          <ng-container *ngSwitchCase="'week'">Today's paper</ng-container>
          <ng-container *ngSwitchCase="'mwne'">Today's paper</ng-container>
          <ng-container *ngSwitchCase="'mlwk'">Today's paper</ng-container>
          <ng-container *ngSwitchCase="'mlne'">Today's paper</ng-container>
          <ng-container *ngSwitchCase="'sema'">Edición de hoy</ng-container>
          <ng-container *ngSwitchDefault>Édition du jour</ng-container>
        </ng-container>
      </p>
      <p *ngIf="pdf.newspaper_name !== 'A19'" class="pdf-number">Numéro {{ pdf.publish_number }}</p>
      <p class="pdf-date">
        <app-timeline-date
          [date]="formatDatePublish(pdf.publish_on)" [category]="category" [themeClass]="themeClass" [isTimeline]="false">
        </app-timeline-date>
      </p>
      <div (click)="downloadPdf(pdf)" class="download-wrapper"><span class="download"></span></div>
    </div>
  </div>
</div>
